<template>
    <div class="group">
        <div
            class="flex-con is-grow xs-pad-lr has-cursor-pointer"
            @click="toggleCollapse"
        >
            <div class="is-narrow">
                <i
                    class="fa"
                    :class="isCollapsed ? 'fa-angle-down' : 'fa-angle-up'"
                ></i>
            </div>
            <div class="heading">
                {{name}}
            </div>
        </div>
        <div
            v-show="!isCollapsed"
            class="items"
        >
            <slot name="options">
                <div
                    v-for="(opt, index) in options"
                    :key="index"
                    @click="select($event, opt)"
                    class="item"
                    :class="{ 'active' : selectedIds.indexOf(opt[optionIdKey]) !== -1 }"
                >
                    <slot name="option" v-bind="{ option : opt }">
                        {{opt[optionNameKey]}}
                    </slot>
                </div>
            </slot>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name : "FilterMenuGroup",
    props : {
        name : {
            type : String,
            required : true,
        },
        uniqueId : {
            type : String,
            required : true,
        },
        options : {
            type : Array,
            required : false,
        },
        selectedIds : {
            type : Array,
            required : false,
        },
        initiallyCollapsed : {
            type : Boolean,
            required : false,
            default : true,
        },
        optionIdKey : {
            type : String,
            required : false,
            default : 'id',
        },
        optionNameKey : {
            type : String,
            required : false,
            default : 'name',
        },
    },
    computed : {
        isCollapsed () {
            const v = this.$store.state.searchGroupCollapseState[this.uniqueId];
            if(v === undefined){
                return this.initiallyCollapsed
            }
            return v;
        },
    },
    methods : {
        toggleCollapse () {
            this.$store.commit('setSearchGroupCollapse', { uniqueId : this.uniqueId, collapsed : !this.isCollapsed });
            this.$emit('toggle-collapsed');
        },
        select (event, opt) {
            this.$emit('selected', { option : opt, addToSelection : event.ctrlKey || event.metaKey });
        },
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/_theme';
    .group {
        padding:5px 10px;
    }
    /deep/ .items {
        margin-left:16px;
        .item {
            cursor:pointer;
            padding:2px;
            line-height:15px;
            border-radius:2px;
            margin-bottom:2px;
            &:hover {
                background-color:$white-bis;
                font-weight:bold;
            }
            &.active {
                background-color:$filterLabelColor;
                border-radius:2px;
                color:$white;
            }
        }
    }
    .heading {
        margin-bottom:0;
    }
</style>
